<div class="case-container">
  <div class="case-header d-flex justify-content-between">
    <div class="d-flex">
      <i [class]="iconClass + ' left-icon'"></i>
      <div class="section-title">{{ title | translate }}</div>
    </div>
    @if(rightIconClass) {
      <i [class]="rightIconClass + ' right-icon'" [ngClass]="{ 'is-disabled': iconDisabled }" (click)="onClickAction()"></i>
    }
    @if(navigationLink) {
      <span class="navigation-link" [routerLink]="[navigationLink.link]">{{ navigationLink.label | translate }}<i class="bi bi-chevron-right"></i></span>
    }
    <button *ngIf="showButton" class="btn btn-primary default-button" (click)="handleButtonClick()">
      <i *ngIf="buttonIconClass" [class]="buttonIconClass"></i>
      {{ buttonLabel | translate }}
    </button>
  </div>
  <ng-content></ng-content>
</div>
